// extracted by mini-css-extract-plugin
module.exports = {"appContainer":"app_appContainer__ru8zT","pageBackground":"app_pageBackground__WCTyD"};